import { ConvrTestName } from "./enums/convr-test-name.enum";
import { ConvrTestVariation } from "./interfaces/convr-test-variation.interface";

export const mockTestData: ConvrTestVariation[] = [
  {
    "order": 0,
    "name": ConvrTestName.MAIN_BUTTON_PART_1,
    "description": "Первая часть текста кнопки на первом экране",
    "variant": {
      "order": 0,
      "payload": "Узнать стоимость"
    }
  },
  {
    "order": 1,
    "name": ConvrTestName.MAIN_BUTTON_PART_2,
    "description": "Вторая часть текста кнопки на первом экране",
    "variant": {
      "order": 0,
      "payload": "онлайн"
    }
  },    
  {
    "order": 2,
    "name": ConvrTestName.MAIN_DESCRIPTION,
    "description": "Описание на первом экране",
    "variant": {
      "order": 1,
      "payload": ""
    }
  },
  {
    "order": 3,
    "name": ConvrTestName.BUTTON_ANIMATION,
    "description": "Цвет всех кнопок",
    "variant": {
      "order": 1,
      "payload": "gradient"
    }
  },
  {
    "order": 4,
    "name": ConvrTestName.BUTTON_FORM,
    "description": "Форма всех кнопок",
    "variant": {
      "order": 1,
      "payload": "squad"
    }
  },
  {
    "order": 5,
    "name": ConvrTestName.VISITS_COUNT,
    "description": "Множитель количества пройденных тестов",
    "variant": {
      "order": 2,
      "payload": 10
    }
  },
  {
    "order": 6,
    "name": ConvrTestName.SERVICE_COUNT,
    "description": "Количество услуг",
    "variant": {
      "order": 1,
      "payload": "DEFAULT"
    }
  },
  {
    "order": 7,
    "name": ConvrTestName.SERVICE_ICONS,
    "description": "Изменение иконок выбора услуг",
    "variant": {
      "order": 1,
      "payload": "DEFAULT"
    }
  },
  {
    "order": 8,
    "name": ConvrTestName.SERVICE_BACKGROUND,
    "description": "Изменение фоновых картинок выбора услуг",
    "variant": {
      "payload": "DEFAULT",
      "order": 0
    }
  },
  {
    "order": 9,
    "name": ConvrTestName.SERVICE_COLUMNS,
    "description": "Кол-во колонок с услугами",
    "variant": {
      "order": 1,
      "payload": 2
    }
  },
  {
    "order": 10,
    "name": ConvrTestName.NEXT_BUTTON,
    "description": "Отображение кнопки далее",
    "variant": {
      "order": 2,
      "payload": "REMOVE"
    }
  },
  {
    "order": 11,
    "name": ConvrTestName.FINAL_BUTTON_PART_1,
    "description": "Первая часть кнопки на экране с вводом номера телефона",
    "variant": {
      "order": 1,
      "payload": "Скачать предложение"
    }
  },
  {
    "order": 12,
    "name": ConvrTestName.FINAL_BUTTON_PART_2,
    "description": "Вторая часть кнопки на экране с вводом номера телефона",
    "variant": {
      "order": 0,
      "payload": "немедленно"
    }
  },
  {
    "order": 13,
    "name": ConvrTestName.PHONE_FORM_HEADER,
    "description": "Заголовок на экране ввода номера телефона",
    "variant": {
      "order": 2,
      "payload": "Тест успешно пройден! Расчет уже готовят наши врачи"
    }
  },
  {
    "order": 14,
    "name": ConvrTestName.PHONE_INPUT_PADDING,
    "description": "Отступы в поле ввода номера телефона",
    "variant": {
      "order": 0,
      "payload": "padding"
    }
  },
  {
    "order": 15,
    "name": ConvrTestName.PHONE_INPUT_BORDER,
    "description": "Рамка вокруг поля ввода номера телефона",
    "variant": {
      "order": 1,
      "payload": "border"
    }
  },
  {
    "order": 16,
    "name": ConvrTestName.PHONE_INPUT_FONT_SIZE,
    "description": "Размер цифр в поле ввода номера телефона",
    "variant": {
      "order": 1,
      "payload": "big_font"
    }
  },
  {
    "order": 17,
    "name": ConvrTestName.SERVICE_ORDER,
    "description": "Порядок следования услуг",
    "variant": {
      "order": 5,
      "payload": ["treatment", "remove", "implantation",  "prosthetics", "crowns", "pediatrics", 
      "gums", "whitening", "veneers", "braces", "cleaning", "rem_wisdom"]
    }
  },
  {
    "order": 18,
    "name": ConvrTestName.WAY_TO_SHOW_SERVICES,
    "description": "Отображение списка услуг - по умолчанию, либо текстом",
    "variant": {
      "order": 1,
      "payload": "DEFAULT"
    }
  },
]